export default {
    errors: {},
};